// import React, { useEffect, useState } from 'react';
// import bannerImage from '../img/aaaservices/3.jpg'; // Update to your image path
 
// const Banner = () => {
//     const [animate, setAnimate] = useState(false);
//     const [showForm, setShowForm] = useState(false);

//     const handleOpenForm = () => setShowForm(true);
//     const handleCloseForm = () => setShowForm(false);

//     useEffect(() => {
//         setAnimate(true);
//     }, []);

//     return (
//         <>
//             <style>{`
//         .banner-container {
//           position: relative;
//           width: 100%;
//           height: 112vh;
//           max-height: 762px;
//           overflow: hidden;
//         }

//         .banner-image {
//           width: 100%;
//           height: 112vh;
//           max-height:762px;
//           object-fit: cover;
//         }

//         .banner-overlay {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background-color: rgba(0, 0, 0, 0.5);
//           z-index: 1;
//         }

//         .banner-text {
//           position: absolute;
//           bottom: 20%;
//           left: 5%;
//           color: white;
//           z-index: 2;
//           opacity: 0;
//           transform: translateY(50px);
//           transition: all 1s ease-out;
//           max-width: 700px;
//         }

//         .banner-text.animate {
//           opacity: 1;
//           transform: translateY(0);
//         }

//         .banner-heading {
//           font-size: 38px;
//           font-weight:bold;
//           margin: 0;
//           letter-spacing:0px;
//         }

//         .banner-heading .blue {
//           color: white;
//           // text-transform: uppercase;
//         }

//         .banner-heading span:last-child {
//           color: gold;
//         }

//         .banner-subheading {
//           font-size: 1.125rem;
//           font-weight: 400;
//           margin-top: 15px;
//           line-height: 1.6;
//           text-align: left;
//           max-width: 600px;
//         }

//         .banner-text button {
//           margin-top: 20px;
//           background-color: #FACC15;
//           color: black;
//           padding: 12px 24px;
//           border-radius: 9999px;
//           border: none;
//           font-weight: 600;
//           cursor: pointer;
//         }

//         @media screen and (max-width: 768px) {
//           .banner-heading {
//             font-size: 2rem;
//           }

//           .banner-subheading {
//             font-size: 1rem;
//             max-width: 90%;
//           }
//         }

//         @media screen and (max-width: 480px) {
//           .banner-heading {
//             font-size: 1.5rem;
//           }

//           .banner-subheading {
//             font-size: 0.875rem;
//           }
//         }

//         .overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background-color: rgba(0, 0, 0, 0.6);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           z-index: 1000;
//         }

//         .modal {
//           background-color: #fff;
//           padding: 30px;
//           border-radius: 12px;
//           width: 90%;
//           max-width: 400px;
//           box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
//           position: relative;
//         }

//         .modal h3 {
//           margin-bottom: 20px;
//           color: rgb(12 133 155);
//         }

//         .modal input {
//           width: 100%;
//           padding: 10px;
//           margin-bottom: 12px;
//           border-radius: 6px;
//           border: 1px solid #ccc;
//         }

//         .modal .submit-button {
//           background-color: #FACC15;
//           color: #fff;
//           padding: 10px;
//           border: none;
//           border-radius: 6px;
//           width: 100%;
//           font-weight: bold;
//           cursor: pointer;
//           margin-top: 10px;
//         }

//         .modal .close-button {
//           position: absolute;
//           top: 10px;
//           right: 10px;
//           background: transparent;
//           border: none;
//           font-size: 18px;
//           cursor: pointer;
//         }
//       `}</style>

//             <div className="banner-container">
//                 <img src={bannerImage} alt="Banner" className="banner-image" />
//                 <div className="banner-overlay"></div>
//                 <div className={`banner-text ${animate ? 'animate' : ''}`}>
//                     <h1 className="banner-heading">
//                         <span className="blue">Who We</span><span>Are</span>
//                     </h1> 
//                     <p className="banner-subheading">
//                     Engineering modern business to Improve everyone’s lives.Let’s discover a new ways of operating, so you can anticipate and act with the technologies.
//                     </p>
//                     {/* <button onClick={handleOpenForm}>Book Your Free Trial Class now →</button> */}
//                 </div>

//                 {showForm && (
//                     <div className="overlay">
//                         <div className="modal">
//                             <h3>Welcome to Envision Group</h3>
//                             <input type="text" placeholder="Name" />
//                             <input type="email" placeholder="Email" />
//                             <input type="tel" placeholder="Mobile" />
//                             {/* <button className="submit-button">Submit</button>
//                             <button onClick={handleCloseForm} className="close-button">X</button> */}
//                         </div>
//                     </div>
//                 )}
//             </div>
             
//         </>
//     );
// };

// export default Banner;




import React, { useEffect, useState } from "react";
import bannerImage from "../img/aaaservices/3.jpg";

const Banner = () => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <>
      <style>{`
        .banner-container {
          position: relative;
          width: 100%;
          height: 50vh;
          max-height: 50vh;

          /* 🔥 Background fixed */
          background-image:
            linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.75)),
            url(${bannerImage});
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          background-attachment: fixed;

          overflow: hidden;
        }

        .banner-text {
          position: absolute;
          bottom: 20%;
          left: 5%;
          color: white;
          z-index: 2;
          opacity: 0;
          transform: translateY(50px);
          transition: all 1s ease-out;
          max-width: 700px;
        }

        .banner-text.animate {
          opacity: 1;
          transform: translateY(0);
        }

        .banner-heading {
          font-size: 38px;
          font-weight: bold;
          margin: 0;
        }

        .banner-heading span:last-child {
          color: gold;
        }

        .banner-subheading {
          font-size: 1.125rem;
          margin-top: 15px;
          line-height: 1.6;
          text-align: left; 
          max-width: 600px;
        }

        @media (max-width: 768px) {
          .banner-container {
            background-attachment: scroll; /* mobile fix */
          }

          .banner-heading {
            font-size: 2rem;
          }
        }
      `}</style>

      <div className="banner-container">
        <div className={`banner-text ${animate ? "animate" : ""}`}>
          <h1 className="banner-heading">
            <span>Who We </span><span>Are</span>
          </h1>

          <p className="banner-subheading">
            Engineering modern business to improve everyone’s lives.
            Let’s discover new ways of operating so you can anticipate
            and act with the latest technologies.
          </p>
        </div>
      </div>
    </>
  );
};

export default Banner;
